import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VhAlgorithm, VhQueryAutoWeb } from 'vhautowebdb';

import { FunctionService , LanguageService } from 'vhobjects-service';
import { JsonDataService } from 'vhobjects-service/src/services';

@Component({
  selector: 'app-edit-menu-header-admin',
  templateUrl: './edit-menu-header-admin.component.html',
  styleUrls: ['./edit-menu-header-admin.component.scss']
})

export class EditMenuHeaderAdminComponent implements OnInit {
  @Input() data: any; // dữ liệu menu từ component cha truyền vào
  @Input() type: any; // dữ liệu menu từ component cha truyền vào
  @Input() isAutoTranslate;
  @Output() isEditMenu = new EventEmitter(); // phát tính hiệu cancel cho component cha
  @Output() valueDataEdited = new EventEmitter(); // phát tính hiệu khi lưu cho component cha

  // Mảng danh sách group (link/category/pop-up)
  listGroupLink = [
    {
      url: 'link',
      name: 'duong_dan'
    },
    {
      url: 'category',
      name: 'goi_danh_muc'
    },
    {
      url: 'pop-up',
      name: 'goi_hop_thoai'
    },
    {
      url: 'pop-up-subcategory',
      name: 'goi_hop_thoai_hien_thi_danh_muc_con'
    }
  ];
  // Mảng danh sách type (none/link-page/website/link-url/category)
  listLink = [
    {
      url: 'none',
      name: 'khong'
    },
    {
      url: 'link-page',
      name: 'den_trang_trong_website'
    },
    {
      url: 'website',
      name: 'lien_ket_website_khac'
    }
  ];

  listBlockPopup = []; // biến chứa dữ liệu các Khối hộp thoại (popup)
  listPageCategory: any = []; // biến chứa dữ liệu các Trang danh mục (category)
  resolution:any;
  isValid: boolean = true; // Biến này xác định form đã valid hay chưa (true: valid; false: chưa)
  
  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb,
    private jsonDataService: JsonDataService,
    public functionService: FunctionService,
    private vhAlgorithm: VhAlgorithm,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit(): void {
    // Lấy dữ liệu
    this.getPageOfCate();
    this.getBlockHoverBlank();

    this.resolution = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    ).resolution;

    // Kiểm tra lần đầu để disabled nút lưu hay không
    this.onChangeAttr();
  }



  /**
   * Lấy danh sách các Trang danh mục (category)
   */
  getPageOfCate() {
    this.vhQueryAutoWeb.getPages_byFields({ type: { $eq: 'detail_category' } }).then(
      (pages: Array<any>) => {
        // Dùng cho trường hợp trang không có name_vn (Hoặc functionService.defaultLanguage)
        const pagesNew = pages.map((page) => {
          // if (!page.name) console.warn('Không có name', page)
          if (!page['name_' + this.functionService.defaultLanguage] && page.name) {
            return {
              ...page,
              ['name_' + this.functionService.defaultLanguage]: page.name
            };
          } else return page;
        });
        this.listPageCategory = this.vhAlgorithm.sortVietnamesebyASC(pagesNew, 'name_' + this.functionService.defaultLanguage);
      });
  }

  /**
   * Lấy danh sách các Khối hộp thoại (popup)
   */
  getBlockHoverBlank() {
    this.vhQueryAutoWeb.getBlocks_byFields({ type: { $in: ['menu_hover', 'hover_blank'] } })
      .then((blocks: any) => {
        this.listBlockPopup = blocks;
      })
  }

  /**
   * Bắt sự kiện thay đổi các trường trong from
   */
  onChangeAttr() {
    const menu = this.data.item;

    setTimeout(() => {
      if (!menu) return;

      const isValidBody =
        (menu.type === 'none') ||
        (menu.type === 'link-page') ||
        (menu.type === 'website' && menu.link_website)

      // Do group === 'category' sẽ có trường riêng là id_page_category và group === 'pop-up' sẽ có trường riêng là id_freeblock, phần còn lại sẽ giống với group === 'link' nên mới dùng cách validate theo group
      // validate theo group (link, category, pop-up)
      const isValidLink = (menu.group === 'link' && isValidBody);
      const isCategoryValid = (menu.group === 'category' && menu.id_page_category != null && isValidBody);
      const isPopUpValid = (menu.group === 'pop-up' && menu.id_freeblock != null && isValidBody);
      const isPopUpSubCategoryValid = (menu.group === 'pop-up-subcategory' && menu.id_freeblock != null && menu.id_page_category != null && isValidBody);

      const checkLangMissingShort = this.functionService.multi_languages.some(lang => !menu[`name_${lang.code}`]?.trim());

      this.isValid = !checkLangMissingShort && (isValidLink || isCategoryValid || isPopUpValid || isPopUpSubCategoryValid);
    }, 50)
  }

  /**
   * Lưu giá trị form chỉnh sửa menu
   */
  saveFormEditMenu() {
    // Xóa các trường không cần
    const menu = this.data.item;
    // Xóa theo type
    const typeFieldsToDeleteMap = {
      'none': ['link_page', 'link_website'],
      'link-page': ['link_website'],
      'website': ['link_page', 'click_action', 'scroll_block_id']
    };
    // Xóa theo group
    const groupFieldsToDeleteMap = {
      'link': ['id_page_category', 'id_freeblock'],
      'category': ['id_freeblock'],
      'pop-up': ['id_page_category']
    };
    // Mảng chứa các trường cần xóa
    const fieldsToDelete = typeFieldsToDeleteMap[menu.type] || [];
    fieldsToDelete.push(...groupFieldsToDeleteMap[menu.group] || []);
    // Xóa
    this.deleteFields(menu, fieldsToDelete);

    if (this.data.item.type === 'link-page' && this.data.item.link_page === undefined) this.data.item.link_page = '';
    let link = this.data.item.link_page;
    link = link ? '/' + link.replace(/^\/+/, '').replace(/\/+$/, '') : '';
    this.data.item.link_page = link === '/' ? '' : link;


    this.valueDataEdited.emit(this.data);
    this.isEditMenu.emit(false);
  }

  /**
   * Xóa các trường trong object
   * @param {Object} data - Object có trường cần xóa
   * @param {Array} fieldsToDelete - Mảng chứa tên các trường cần xóa
   */
  deleteFields(data, fieldsToDelete) {
    fieldsToDelete.forEach(field => {
      delete data[field];
    });
  }

  /**
   * Đóng form sửa menu
   */
  cancelFormEditMenu(){
    this.isEditMenu.emit(false);
  }

  createNewBlock() {
    this.jsonDataService
        .getBlock('hover_blank')
        .subscribe((result: any) => {
          if(result) {
            let dataBlock = {
              ...result,
              name: result.name + ' ' + (this.listBlockPopup.length + 1),
              ['desktop_position_']: {
                ...result['desktop_position'],
                width: this.resolution['desktop_width'] - 1,
              },
              ['mobile_portrait_position_']: {
                ...result['mobile_portrait_position'],
                width: this.resolution['mobile_portrait_width'] - 1,
              },
              ['tablet_landscape_position_']: {
                ...result['tablet_landscape_position'],
                width: this.resolution['tablet_landscape_width'] - 1,
              },
              ['tablet_portrait_position_']: {
                ...result['tablet_portrait_position'],
                width: this.resolution['tablet_portrait_width'] - 1,
              },
              ['mobile_landscape_position_']: {
                ...result['mobile_landscape_position'],
                width: this.resolution['mobile_landscape_width'] - 1,
              },
              type: 'hover_blank',
            };

            dataBlock.desktop_class[result.resize_field]['width'] = (this.resolution['desktop_width'] -1)+'px';
            dataBlock.desktop_class[result.resize_field]['min-height'] = result['desktop_position'].height+'px'

            dataBlock.mobile_portrait_class[result.resize_field]['width'] = (this.resolution['mobile_portrait_width'] - 1)+'px';
            dataBlock.mobile_portrait_class[result.resize_field]['min-height'] = result['mobile_portrait_position'].height+'px'

            dataBlock.mobile_landscape_class[result.resize_field]['width'] = (this.resolution['mobile_landscape_width'] - 1)+'px';
            dataBlock.mobile_landscape_class[result.resize_field]['min-height'] = result['mobile_landscape_position'].height+'px'

            dataBlock.tablet_landscape_class[result.resize_field]['width'] = (this.resolution['tablet_landscape_width'] - 1)+'px';
            dataBlock.tablet_landscape_class[result.resize_field]['min-height'] = result['tablet_landscape_position'].height+'px'

            dataBlock.tablet_portrait_class[result.resize_field]['width'] = (this.resolution['tablet_portrait_width'] -1)+'px';
            dataBlock.tablet_portrait_class[result.resize_field]['min-height'] = result['tablet_portrait_position'].height+'px'



            dataBlock.desktop_config.dimension = {
              width: this.resolution['desktop_width'] - 1,
              height: result['desktop_position'].height
            }
            dataBlock.mobile_portrait_config.dimension = {
              width: this.resolution['mobile_portrait_width'] - 1,
              height: result['mobile_portrait_position'].height
            }
            dataBlock.mobile_landscape_config.dimension = {
              width: this.resolution['mobile_landscape_width'] - 1,
              height: result['mobile_landscape_position'].height
            }
            dataBlock.tablet_landscape_config.dimension = {
              width: this.resolution['tablet_landscape_width'] - 1,
              height: result['tablet_landscape_position'].height
            }
            dataBlock.tablet_portrait_config.dimension = {
              width: this.resolution['tablet_portrait_width'] - 1,
              height: result['tablet_portrait_position'].height
            }


            this.vhQueryAutoWeb.addBlock(dataBlock)
              .then((block: any) => {
              this.listBlockPopup.push(block);
              this.functionService.createMessage('success', 'them_khoi_thanh_cong');
            })
          }
        });
  }

  autoTranslateNameLang() {    
    if (this.isAutoTranslate && this.data.item['name_' + this.functionService.languageTempCode]) {
      this.functionService.showLoading(
        this.languageService.translate('dang_dich_cac_ngon_ngu_con_lai_cho_ten_menu'),
        "current-loading", null, 0, false
      ).then(() => {
        this.functionService.translateToMultipleLanguages(
          this.data.item['name_' + this.functionService.languageTempCode],
          { isAdmin: true }
        )
        .subscribe({
          next: (data) => {
            // console.log('data', data)
            this.functionService.multi_languages.forEach(lang => {
              if (this.functionService.languageTempCode != lang.code) {
                this.data.item['name_' + lang.code] = data.find(
                  item => item.langCode == lang.code
                ).translatedText;
              }
            });
            this.onChangeAttr(); // Cập nhật lại để nút "Thêm" hủy disabled
            this.functionService.hideLoading(300);
          },
          error: (err) => {
            console.error('Lỗi dịch thuật:', err);
            this.functionService.hideLoading(300);
          }
        });
      });
    }
  }
}
